module.exports = __webpack_public_path__ + "img/manual.b0eb0f6d.png";